import React, { useContext } from 'react';
import { Box, Typography } from '@material-ui/core';
import { SessionContext } from '../../../../../state/Session';
import UserRoles from '../../../../../types/UserRoles';
import { useScope } from '../../../../../hooks/useScope';
import LoadingIndicator from '@/components/core/LoadingIndicator';

interface StaffCostAccessProps {
  children: React.ReactNode;
}

const StaffCostAccess: React.FC<StaffCostAccessProps> = ({ children }) => {
  const sessionContext = useContext(SessionContext) as any;
  const roles = (sessionContext.session?.user?.metadata ?? []) as string[];
  const isSuperAdmin = roles.indexOf(UserRoles.SuperAdmin) >= 0;
  const staffCostAccess = sessionContext.session?.account?.metadata?.staffCostAccess;
  const scope = useScope();

  // Show loading while scope is being fetched
  if (!scope) {
    return <LoadingIndicator />;
  }

  const showStaffCost = scope?.hospital?.modules?.showStaffCost;

  // Super admins always have access
  if (isSuperAdmin) {
    return <>{children}</>;
  }

  // Check if staff cost module is enabled
  if (!showStaffCost) {
    return (
      <Box display="flex" alignItems="center" justifyContent="center" height="100vh">
        <Typography variant="h5">Staff cost module is not enabled for this hospital</Typography>
      </Box>
    );
  }

  // Check if user has staff cost access
  if (!staffCostAccess) {
    return (
      <Box display="flex" alignItems="center" justifyContent="center" height="100vh">
        <Typography variant="h5">You do not have access to view this page</Typography>
      </Box>
    );
  }

  return <>{children}</>;
};

export default StaffCostAccess; 